import { ExamType } from "../../../model/Exam";
import { ExamSessionCandidateExamState } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";

export const manualStates = [ExamSessionCandidateExamState.Passed, ExamSessionCandidateExamState.Failed];
const termPaperManualStates = [...manualStates, ExamSessionCandidateExamState.Equivalence];

export const getManualStates = (examType: ExamType) =>
  examType === ExamType.TermPaper ? termPaperManualStates : manualStates;
